
define('template!pimVariationPrintAreasTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pim-section-header">\n    <div class="pim-section-label" title="' +
__e( _.i18n('pim.variationPrintAreas.hint', null, 'Print areas of the editor, attached to groups of variations: finished format, bleed, security border and techniques. Never shown on the webshop, never priced.') ) +
'">\n        ' +
__e( _.i18n('pim.variationPrintAreas.title', null, 'Variation print areas') ) +
'\n    </div>\n    ';
 if (hasResProduct) { ;
__p += '\n    <button class="btn-vpa-add js-vpa-add">' +
__e( _.i18n('pim.variationPrintAreas.add', null, 'Add a print area') ) +
'</button>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (!hasResProduct) { ;
__p += '\n<div class="pim-vpa-empty">' +
__e( _.i18n('pim.variationPrintAreas.noResellerProduct', null, 'Create the reseller product first: the print areas are saved on it.') ) +
'</div>\n';
 } else if (loading) { ;
__p += '\n<div class="pim-vpa-empty">' +
__e( _.i18n('common.loading', null, 'Loading...') ) +
'</div>\n';
 } else if (error) { ;
__p += '\n<div class="pim-vpa-error">' +
__e( error ) +
'</div>\n';
 } else if (!areas.length) { ;
__p += '\n<div class="pim-vpa-empty">' +
__e( _.i18n('pim.variationPrintAreas.none', null, 'No print area yet: the editor has nothing to print on for this product.') ) +
'</div>\n';
 } else { ;
__p += '\n<div class="pim-vpa-table-wrapper">\n    <table class="pim-vpa-table">\n        <thead>\n        <tr>\n            <th>' +
__e( _.i18n('common.code', null, 'Code') ) +
'</th>\n            <th>' +
__e( _.i18n('common.name', null, 'Name') ) +
'</th>\n            <th>' +
__e( _.i18n('pim.variationPrintAreas.format', null, 'Finished format') ) +
'</th>\n            <th>' +
__e( _.i18n('pim.variationPrintAreas.lostBorder', null, 'Bleed') ) +
'</th>\n            <th>' +
__e( _.i18n('pim.variationPrintAreas.securityBorder', null, 'Security border') ) +
'</th>\n            <th>' +
__e( _.i18n('pim.variationPrintAreas.techniques', null, 'Techniques') ) +
'</th>\n            <th>' +
__e( _.i18n('pim.variationPrintAreas.variations', null, 'Variations') ) +
'</th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        ';
 _.each(areas, function (area) { ;
__p += '\n        <tr data-id="' +
__e( area.id ) +
'">\n            <td class="pim-vpa-code">' +
__e( area.code ) +
'</td>\n            <td>' +
__e( area.name ) +
'</td>\n            <td>' +
__e( area.format ) +
'</td>\n            <td><span class="pim-vpa-swatch pim-vpa-swatch-lost"></span>' +
__e( area.lostBorder ) +
'</td>\n            <td><span class="pim-vpa-swatch pim-vpa-swatch-safe"></span>' +
__e( area.securityBorder ) +
'</td>\n            <td>\n                ';
 _.each(area.techniques, function (tech) { ;
__p += '\n                <span class="pim-vpa-tech ' +
((__t = ( tech.isDefault ? 'pim-vpa-tech-default' : '' )) == null ? '' : __t) +
'" title="' +
__e( tech.name ) +
'' +
__e( tech.isDefault ? ' (' + _.i18n('pim.variationPrintAreas.default', null, 'default') + ')' : '' ) +
'">' +
__e( tech.code ) +
'</span>\n                ';
 }) ;
__p += '\n            </td>\n            <td title="' +
__e( area.rules ) +
' ' +
__e( _.i18n('pim.variationPrintAreas.rules', null, 'rules') ) +
', ' +
__e( area.extraCodes ) +
' ' +
__e( _.i18n('pim.variationPrintAreas.extraCodes', null, 'extra variation codes') ) +
'">\n                ' +
__e( area.count === null ? '…' : area.count ) +
'\n            </td>\n            <td class="pim-vpa-actions">\n                <i class="mdi-editor-mode-edit clickable js-vpa-edit" title="' +
__e( _.i18n('common.edit', null, 'Edit') ) +
'"></i>\n                <i class="mdi-action-delete clickable js-vpa-delete" title="' +
__e( _.i18n('common.delete', null, 'Delete') ) +
'"></i>\n            </td>\n        </tr>\n        ';
 }) ;
__p += '\n        </tbody>\n    </table>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

